/* Landing page — Festival edition */
const LandingPage = ({ t, setTweak }) => {
  const D = window.PA_DATA;
  const visibleParcours = D.parcours.filter(p => p.status !== "past");
  const featured = visibleParcours.filter(p => p.status === "live" || p.status === "soon").slice(0, 4);
  const live = D.parcours.find(p => p.status === "live");

  return (
    <div data-screen-label="01 Landing">

      {/* ===== HERO ===== */}
      <Hero visibleParcours={visibleParcours}/>

      {/* ===== PARCOURS COUPS DE CŒUR ===== */}
      <section className="container-w section-tight landing-mozaika-section">
        <SectionTitle
          eyebrow="Programme 2026"
          title="Parcours à venir"
          italic="près de chez vous"
          action={<a href="/parcours" className="btn btn-light">Tous les parcours →</a>}
        />
        <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(280px, 1fr))", gap:24}}>
          {featured.slice(0,3).map((p,i) => <ParcoursCard key={p.id} p={p}/>)}
        </div>
        <div className="row" style={{justifyContent:"center", marginTop:32}}>
          <a href="/parcours" className="btn btn-light">Tous les parcours →</a>
        </div>
      </section>

      {/* ===== REGION EXPLORER ===== */}
      <RegionExplorer visibleParcours={visibleParcours}/>

      {/* ===== CARTE — VRAIE OL (temporairement masquée) ===== */}
      {/* <RegionalMapSection visibleParcours={visibleParcours}/> */}

      {/* ===== POURQUOI DIGITALISER ===== */}
      <section className="container-w section">
        <SectionTitle
          eyebrow="Pourquoi"
          title="Digitalisez votre parcours d'artistes."
          italic="Notre offre de services."
          sub="Une page web vivante remplace le programme imprimé : à jour, partageable, accessible, mesurable."
        />
        <div style={{display:"grid", gridTemplateColumns:"repeat(3, 1fr)", gap:24}}>
          {[
            { n:"01", icon:"calendar", color:"var(--pink)", t:"Toujours à jour",
              d:"Une exposition se déplace ? Un artiste annule ? Vous modifiez. Le public voit en temps réel." },
            { n:"02", icon:"map", color:"var(--yellow)", t:"Géolocalisé",
              d:"Chaque lieu est posé sur la carte. Itinéraires en voiture, à vélo ou à pied. Sans application à installer." },
            { n:"03", icon:"chart", color:"var(--green)", t:"Mesurable",
              d:"Vous savez quelles œuvres attirent. Quels jours fonctionnent. Quels publics touchez-vous." }
          ].map(c => (
            <div key={c.n} className="card stack gap-5" style={{padding:36, minHeight:280, border:"1.5px solid var(--ink)"}}>
              <div className="between">
                <span className="mono muted">{c.n}</span>
                <div style={{
                  width:50, height:50, borderRadius:8,
                  background:c.color, color:"var(--ink)",
                  display:"flex", alignItems:"center", justifyContent:"center"
                }}>
                  <Icon name={c.icon} size={22}/>
                </div>
              </div>
              <div className="display" style={{fontSize:38, lineHeight:0.95}}>{c.t}</div>
              <p className="muted" style={{margin:0, fontSize:14.5, lineHeight:1.55}}>{c.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== POUR LES ORGANISATEURS ===== */}
      <section className="container-w section-tight">
        <div style={{
          background:"var(--paper-warm)",
          border:"1.5px solid var(--ink)",
          borderRadius:18,
          padding:"44px 42px",
          position:"relative",
          overflow:"hidden"
        }}>
          <Tape color="yellow" style={{top:-10, left:56, width:130, height:22, transform:"rotate(-4deg)"}}/>
          <div className="stack gap-6" style={{position:"relative", zIndex:2}}>
            <SectionTitle
              eyebrow="Mozaika"
              title="Mozaika, la plateforme"
              italic="qui dynamise vos artistes locaux"
              sub="Le site Parcours d'Artistes vous est proposé par Mozaika.be, destiné aux communes qui veulent mettre en avant les artistes locaux. Mozaika vous propose de faire l'inventaire des artistes, de leur donner la possibilité de se présenter, de présenter leur oeuvre, mais aussi d'organiser des événements, de digitaliser vos parcours d'artistes ou encore de communiquer à travers les réseaux sociaux."
            />
            <div className="row gap-3 wrap landing-mozaika-actions">
              <a href="/publier" className="btn btn-primary">
                Publier mon parcours →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ===== TÉMOIGNAGE ===== */}
      {/* <section className="container-w section-tight">
        <div className="row between wrap" style={{gap:40, alignItems:"center"}}>
          <div style={{maxWidth:840}}>
            <h2 style={{fontSize:"clamp(36px, 4vw, 64px)", lineHeight:1}}>
              <Marker color="yellow" rotate={-2}>«</Marker> On a remplacé un PDF
              <br/>
              que personne ne lisait par
              <br/>
              une page que tout le monde
              <br/>
              partage. <Marker color="pink" rotate={2}>»</Marker>
            </h2>
            <div className="row gap-3" style={{marginTop:28}}>
              <div style={{width:48, height:48, borderRadius:"50%", overflow:"hidden", background:"var(--paper-3)", border:"1.5px solid var(--ink)"}}>
                <img src={window.PA_DATA.portrait("soph", 120, 120)} alt=""
                     style={{width:"100%", height:"100%", objectFit:"cover", filter:"grayscale(100%)"}}/>
              </div>
              <div className="stack" style={{lineHeight:1.3}}>
                <span style={{fontSize:14, fontWeight:600}}>Anne Vandersteen</span>
                <span className="mono muted">Coordinatrice · Office du Tourisme de Spa</span>
              </div>
            </div>
          </div>
          <div className="row gap-4">
            <Stat n={window.PA_DATA.artists.length} label="artistes"/>
            <Stat n={window.PA_DATA.venues.length} label="lieux"/>
            <Stat n={window.PA_DATA.parcours.length} label="parcours"/>
          </div>
        </div>
      </section> */}

      {/* ===== FINAL CTA ===== */}
      <section className="container-w section">
        <div className="big-cta" style={{
          background:"var(--ink)", color:"var(--paper-warm)",
          padding:"96px 56px", borderRadius:24, textAlign:"center",
          position:"relative", overflow:"hidden"
        }}>
          <AsteriskHand color="var(--pink)" size={60} style={{
            position:"absolute", left:80, top:80, transform:"rotate(15deg)"
          }}/>
          <AsteriskHand color="var(--yellow)" size={50} style={{
            position:"absolute", right:120, top:120, transform:"rotate(-22deg)"
          }}/>
          <AsteriskHand color="var(--green)" size={42} style={{
            position:"absolute", left:160, bottom:80, transform:"rotate(30deg)"
          }}/>
          <div style={{position:"relative", zIndex:1}}>
            <span className="mono" style={{color:"var(--paper-3)"}}>· Prêt ·</span>
            <h2 style={{color:"var(--paper-warm)", margin:"28px 0", fontSize:"clamp(48px, 7vw, 116px)"}}>
              Sortez. <span className="script" style={{color:"var(--yellow)", fontSize:"0.82em"}}>regardez.</span>
              <br/>
              Rentrez chez vous différent.
            </h2>
            <div className="row gap-3 wrap landing-final-cta-actions" style={{justifyContent:"center", marginTop:40}}>
              <a href="/parcours" className="btn btn-accent">
                Explorer les parcours →
              </a>
              <a href="/publier" className="btn" style={{
                background:"transparent", color:"var(--paper-warm)",
                border:"1.5px solid var(--paper-warm)"
              }}>Publier mon parcours</a>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

/* ================== HERO ================== */
const Hero = ({ visibleParcours }) => {
  const D = window.PA_DATA;
  // Le hero met en avant un parcours à venir. On préfère celui qui a une vraie
  // affiche : sinon le cadre retombe sur le collage d'illustration.
  const upcoming = D.parcours.filter(p => p.status !== "past");
  const featured = upcoming.find(p => p.hasImage) || upcoming[0] || D.parcours[0];
  // Année de l'édition : déduite du parcours mis en avant, plus de « 2026 » en dur.
  const editionYear = (featured && featured.startISO && featured.startISO.slice(0, 4)) || String(new Date().getFullYear());
  const [searchQuery, setSearchQuery] = React.useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Page unifiée /search — interroge parcours + artistes + lieux
      window.location.href = `/search?q=${encodeURIComponent(searchQuery.trim())}`;
    }
  };

  return (
    <section className="container-w relative" style={{paddingTop:36, paddingBottom:80, position:"relative"}}>
      {/* Background painted strokes */}
      <BrushStroke className="deco-stroke" color="var(--pink)" style={{
        position:"absolute", width:180, height:46, top:90, left:"36%", opacity:0.95, zIndex:0,
        transform:"rotate(-6deg)", pointerEvents:"none"
      }}/>
      <BrushStroke className="deco-stroke" color="var(--orange)" style={{
        position:"absolute", width:140, height:36, bottom:90, right:120, opacity:0.95, zIndex:0,
        transform:"rotate(8deg)", pointerEvents:"none"
      }}/>

      <div className="split-2" style={{
        display:"grid",
        gridTemplateColumns:"minmax(0, 1.05fr) minmax(0, 1fr)",
        gap:48, alignItems:"center", position:"relative", zIndex:2
      }}>
        <div className="stack gap-7" style={{paddingTop:16, position:"relative"}}>
          <Stamp color="var(--ink)">· Propulsée par Mozaika.be·</Stamp>

          <div style={{position:"relative"}}>
            <h1 className="hero-title" style={{
              fontSize:"clamp(56px, 7.8vw, 132px)",
              letterSpacing:"-0.025em", lineHeight:0.9, margin:0
            }}>
              L'ART SE
              <br/>
              DÉCOUVRE
              <br/>
              <span style={{position:"relative", display:"inline-block"}}>
                À CÔTÉ
                <DoodleArrow color="var(--pink)" style={{
                  position:"absolute", width:50, height:70,
                  top:-12, right:-66, transform:"rotate(20deg)"
                }}/>
              </span>
              <br/>
              <span className="script" style={{
                color:"var(--ink)", fontSize:"0.6em",
                position:"relative", display:"inline-block"
              }}>
                <span style={{position:"relative", zIndex:1}}>de chez vous</span>
                <span style={{
                  position:"absolute", inset:"-4px -8px",
                  background:"var(--yellow)",
                  clipPath:"polygon(1% 8%, 99% 0%, 100% 86%, 97% 100%, 3% 96%, 0% 12%)",
                  transform:"rotate(-1deg)",
                  zIndex:0
                }}/>
              </span>
            </h1>
          </div>

          <p style={{fontSize:17, lineHeight:1.55, color:"var(--ink-soft)", maxWidth:480, margin:0}}>
            La plateforme qui digitalise les parcours d'artistes. Cartes, programmes, lieux, artistes.
          </p>

          <form onSubmit={handleSearch} style={{maxWidth:480}}>
            <div className="search-bar" style={{maxWidth:480, padding:"5px 5px 5px 22px"}}>
              <Icon name="search" size={16} style={{color:"var(--ink-mute)"}}/>
              <input
                placeholder="Commune, artiste, parcours..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit" className="btn btn-icon btn-primary" style={{width:44, height:44}}>
                <Icon name="arrow-right" size={16}/>
              </button>
            </div>
          </form>

          <div className="row gap-6 mono muted">
            <span>· {D.artists.length} artistes</span>
            <span>· {D.venues.length} lieux</span>
            <span>· {visibleParcours.length} parcours</span>
          </div>
        </div>

        <div style={{position:"relative", minHeight:560}}>
          <a href={featured ? `/parcours/${featured.slug}` : "/parcours"}
             className="hero-main-photo"
             aria-label={featured ? `Voir le parcours ${featured.title}` : "Voir les parcours"}
             style={{
               position:"absolute", top:0, right:0, width:"94%", height:520,
               borderRadius:10, overflow:"hidden", border:"1.5px solid var(--ink)",
               background:"var(--paper-3)", zIndex:1, display:"block"
             }}>
            <img src={(featured && featured.image) || "/assets/hero-landing.png"}
                 alt={featured ? featured.title : ""}
                 style={{width:"100%", height:"100%", objectFit:"cover", objectPosition:"center top", display:"block"}}/>
            <Tape color="yellow" style={{top:-12, left:40, width:140, height:26, transform:"rotate(-5deg)"}}/>
            <Tape color="pink" style={{bottom:30, right:-20, width:120, height:22, transform:"rotate(6deg)"}}/>
          </a>

          {featured && featured.dates && (
            <div className="hero-date-sticker" style={{
              position:"absolute", top:40, left:-10, zIndex:4
            }}>
              <Marker color="pink" rotate={-4} style={{padding:"14px 22px", maxWidth:230}}>
                <span className="display" style={{
                  display:"block", textAlign:"center",
                  fontSize:17, lineHeight:1.15, color:"var(--ink)"
                }}>{featured.dates.toUpperCase()}</span>
              </Marker>
            </div>
          )}

          <div className="hero-stat-circle" style={{
            position:"absolute", bottom:-20, left:-30, zIndex:5,
            width:120, height:120, borderRadius:"50%",
            background:"var(--ink)", color:"var(--paper)",
            border:"3px solid var(--paper)",
            boxShadow:"var(--shadow-l)",
            display:"flex", flexDirection:"column",
            alignItems:"center", justifyContent:"center"
          }}>
            <div className="display" style={{fontSize:42, lineHeight:1, color:"var(--pink)"}}>{D.artists.length}</div>
            <div className="mono" style={{color:"var(--paper-3)", marginTop:4}}>artistes<br/>en {editionYear}</div>
          </div>

          <div className="hero-yellow-tag" style={{
            position:"absolute", right:-20, bottom:80, zIndex:4,
            background:"var(--yellow)", color:"var(--ink)",
            padding:"14px 18px",
            border:"1.5px solid var(--ink)",
            transform:"rotate(3deg)",
            boxShadow:"var(--shadow)"
          }}>
            <div className="display" style={{fontSize:13, lineHeight:1.1}}>ÉDITION<br/>{editionYear}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

const RegionOSMBackdrop = ({ region, communes }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !window.ol) return;

    const map = new ol.Map({
      target: ref.current,
      controls: [],
      interactions: ol.interaction.defaults.defaults({
        mouseWheelZoom: false,
        dragPan: false,
        doubleClickZoom: false,
        pinchZoom: false,
        keyboard: false,
        shiftDragZoom: false,
        altShiftDragRotate: false
      }),
      layers: [
        window.baseTileLayer({ opacity: 0.9 })
      ],
      view: new ol.View({
        center: ol.proj.fromLonLat([4.55, 50.66]),
        zoom: 8
      })
    });

    const src = new ol.source.Vector();
    const overlayLayer = new ol.layer.Vector({
      source: src,
      style: new ol.style.Style({
        fill: new ol.style.Fill({ color: "rgba(255, 62, 143, 0.08)" }),
        stroke: new ol.style.Stroke({
          color: "#0F0F0F",
          width: 2,
          lineDash: [6, 4]
        })
      })
    });
    map.addLayer(overlayLayer);

    const drawFeature = (geojson) => {
      if (!geojson) return null;
      const reader = new ol.format.GeoJSON();
      const features = reader.readFeatures(
        { type: "Feature", geometry: geojson },
        { featureProjection: "EPSG:3857" }
      );
      src.addFeatures(features);
      return features;
    };

    const fitAll = () => {
      if (!src.getFeatures().length) return;
      map.getView().fit(src.getExtent(), {
        padding: [20, 20, 20, 20],
        maxZoom: 9,
        duration: 300
      });
    };

    (async () => {
      try {
        const provinceUrl =
          "https://nominatim.openstreetmap.org/search?format=json&polygon_geojson=1&limit=1&countrycodes=be&q=" +
          encodeURIComponent(region + ", Belgique");
        const provinceRes = await fetch(provinceUrl, { headers: { "Accept-Language": "fr" } });
        const provinceData = await provinceRes.json();
        const provinceGeo = provinceData[0]?.geojson;

        if (provinceGeo) {
          drawFeature(provinceGeo);
          fitAll();
          return;
        }
      } catch (e) {}

      // Fallback: draw available commune polygons if province cannot be resolved.
      try {
        for (const commune of communes) {
          const geo = await window.fetchCommunePolygon(commune);
          drawFeature(geo);
        }
        fitAll();
      } catch (e) {}
    })();

    return () => map.setTarget(undefined);
  }, [region, communes]);

  return <div ref={ref} className="ol-map" style={{position:"absolute", inset:0, filter:"saturate(1.55) contrast(1.15)"}} />;
};

/* ================== REGION EXPLORER ================== */
const RegionExplorer = ({ visibleParcours }) => {
  const colors = ["pink","yellow","green","purple","orange"];

  // Group parcours by their `region` field directly (single source of truth from the backend).
  // Each parcours belongs to exactly one region → no double-counting.
  const regionMap = {};
  visibleParcours
    .filter(p => p.status === "soon" || p.status === "live")
    .forEach(p => {
      const region = (p.region || "").trim();
      if (!region) return; // parcours without region → excluded from the explorer
      if (!regionMap[region]) {
        regionMap[region] = { region, parcours: [], communes: new Set() };
      }
      regionMap[region].parcours.push(p);
      (p.communes || []).forEach(c => c && regionMap[region].communes.add(c));
    });

  const regions = Object.values(regionMap).sort((a, b) => b.parcours.length - a.parcours.length);

  if (regions.length === 0) {
    return null; // Don't show section if no active/upcoming parcours
  }
  
  return (
    <section className="container-w section-tight">
      <div className="row between wrap" style={{gap:24, marginBottom:32}}>
        <h2 style={{fontSize:48}}>
          <span style={{borderBottom:"4px solid var(--ink)", paddingBottom:6}}>Explorer par région</span>
        </h2>
        <a href="/parcours" className="btn btn-light btn-sm"><Icon name="map" size={13}/> Tous les parcours</a>
      </div>
      <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(320px, 420px))", gap:24}}>
        {regions.map((r, i) => (
          <a key={r.region} href={`/parcours?region=${encodeURIComponent(r.region)}`} className="stack gap-3 relative" style={{textDecoration:"none"}}>
            <Tape color={colors[i % colors.length]} style={{top:-10, left:24, width:80, height:18, transform:`rotate(${i%2===0?-6:6}deg)`}}/>
            <div className="card relative" style={{
              minHeight:230, overflow:"hidden", borderRadius:10, position:"relative",
              border:"1.5px solid var(--ink)",
              background:"var(--paper-warm)",
              display:"flex",
              flexDirection:"column",
              justifyContent:"space-between",
              padding:14
            }}>
              <div style={{position:"absolute", inset:0, opacity:0.5, pointerEvents:"none"}}>
                <RegionOSMBackdrop region={r.region} communes={[...r.communes]} />
              </div>
              <div style={{
                position:"absolute",
                inset:0,
                background:"rgba(248, 244, 234, 0.2)",
                pointerEvents:"none"
              }}/>
              <div className="row" style={{justifyContent:"space-between", alignItems:"flex-start", position:"relative", zIndex:2}}>
                <div className="mono" style={{
                  fontSize:10,
                  letterSpacing:"0.08em",
                  color:"var(--ink)",
                  fontWeight:700,
                  background:"var(--paper-warm)",
                  border:"1.5px solid var(--ink)",
                  borderRadius:4,
                  padding:"4px 8px"
                }}>
                  {r.parcours.length} parcours
                </div>
                <div style={{
                  background:"var(--paper-warm)",
                  border:"1.5px solid var(--ink)",
                  borderRadius:4,
                  padding:4,
                  lineHeight:0
                }}>
                  <Icon name="map" size={14} style={{color:"var(--ink)"}}/>
                </div>
              </div>
              <div style={{
                background:"var(--paper-warm)", padding:"10px 14px",
                border:"1.5px solid var(--ink)", borderRadius:8,
                position:"relative", zIndex:2,
                maxWidth:"100%"
              }}>
                <div className="display" style={{
                  fontSize:"clamp(13px, 2.4vw, 18px)",
                  lineHeight:1.1,
                  wordBreak:"break-word",
                  hyphens:"auto"
                }}>{r.region}</div>
              </div>
            </div>
            <div className="mono" style={{paddingLeft:8, color:"var(--ink)", fontWeight:700}}>
              {r.communes.size} commune{r.communes.size>1?"s":""} · {r.parcours.length} parcours
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

/* ================== REGIONAL MAP ================== */
const RegionalMapSection = ({ visibleParcours }) => {
  const D = window.PA_DATA;
  return (
    <section className="container-w section">
      <div style={{
        background:"var(--ink)", color:"var(--paper-warm)",
        padding:"56px 48px", borderRadius:24, position:"relative", overflow:"hidden"
      }}>
        <div className="split-2" style={{
          display:"grid",
          gridTemplateColumns:"minmax(0, 1fr) minmax(0, 1.1fr)",
          gap:48, alignItems:"center", position:"relative", zIndex:1
        }}>
          <div className="stack gap-5" style={{minWidth:0}}>
            <span className="mono" style={{color:"var(--pink)"}}>· La carte ·</span>
            <h2 style={{color:"var(--paper-warm)", fontSize:"clamp(40px, 4.5vw, 72px)", lineHeight:0.92}}>
              {visibleParcours.reduce((s,p)=>s+p.communes.length,0)} COMMUNES,<br/>
              <span className="script" style={{color:"var(--yellow)", fontSize:"0.7em"}}>une seule carte.</span>
            </h2>
            <p style={{fontSize:16, lineHeight:1.5, color:"var(--paper-3)"}}>
              Tous les parcours d'artistes sur une seule carte. Géolocalisez les lieux ouverts, filtrez par commune, par parcours.
            </p>
            <div className="row gap-3 wrap">
              <a href="/parcours" className="btn btn-accent">Voir les parcours →</a>
              <a href="/parcours" className="btn" style={{color:"var(--paper-warm)", border:"1.5px solid var(--paper-3)"}}>
                Voir les parcours
              </a>
            </div>
            <div className="row gap-4 mono wrap" style={{color:"var(--paper-3)", marginTop:4}}>
              <span>· {visibleParcours.length} parcours</span><span>· {D.artists.length} artistes</span><span>· {D.venues.length} lieux</span>
            </div>
          </div>
          <div style={{position:"relative", minWidth:0}}>
            <Tape color="yellow" style={{top:-12, left:40, width:120, height:22, zIndex:5}}/>
            <Tape color="pink" style={{top:-12, right:40, width:120, height:22, zIndex:5, transform:"rotate(6deg)"}}/>
            <div style={{
              height:380, borderRadius:10, overflow:"hidden", padding:0, border:"3px solid var(--paper)",
              boxShadow:"var(--shadow-l)"
            }}>
              <MiniMap
                lonlats={D.venues.map(v => v.lonlat)}
                center={[4.55, 50.66]}
                zoom={10}
                pinColor="#FF3E8F"
                style={{width:"100%", height:"100%"}}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

/* ================== ORGANIZER BLOCK ================== */
// const OrganizerBlock = () => {
//   const D = window.PA_DATA;
//   return (
//     <section className="container-w section">
//       <div style={{
//         background:"var(--ink)", color:"var(--paper-warm)",
//         borderRadius:24, padding:"64px 56px",
//         position:"relative", overflow:"hidden"
//       }}>
//         {/* Floating asterisk doodles */}
//         <AsteriskHand color="var(--pink)" size={44} style={{
//           position:"absolute", left:70, top:60, transform:"rotate(15deg)"
//         }}/>
//         <AsteriskHand color="var(--yellow)" size={36} style={{
//           position:"absolute", right:520, bottom:80, transform:"rotate(-20deg)"
//         }}/>

//         <div className="split-2" style={{
//           display:"grid",
//           gridTemplateColumns:"minmax(0, 1.05fr) minmax(0, 1fr)",
//           gap:56, alignItems:"center", position:"relative", zIndex:1
//         }}>
//           {/* LEFT — pitch */}
//           <div className="stack gap-6">
//             <span className="mono" style={{color:"var(--pink)"}}>· Pour les communes & collectifs ·</span>

//             <h2 style={{
//               fontSize:"clamp(48px, 6vw, 104px)", lineHeight:0.9,
//               color:"var(--paper-warm)"
//             }}>
//               VOUS ORGANISEZ
//               <br/>
//               UN <span style={{position:"relative", display:"inline-block"}}>
//                 PARCOURS
//                 <DoodleArrow color="var(--yellow)" style={{
//                   position:"absolute", width:50, height:70,
//                   top:-12, right:-66, transform:"rotate(20deg)"
//                 }}/>
//               </span>{" "}?
//               <br/>
//               <span className="script" style={{color:"var(--yellow)", fontSize:"0.55em"}}>
//                 on s'occupe du reste.
//               </span>
//             </h2>

//             <p style={{fontSize:16.5, lineHeight:1.55, color:"var(--paper-3)", maxWidth:520, margin:0}}>
//               La plateforme officielle pour digitaliser, gérer et partager les parcours d'artistes. Page publique, carte, programme, statistiques — tout en un.
//             </p>

//             {/* Feature tags as colored stickers */}
//             <div className="row gap-3 wrap" style={{marginTop:8}}>
//               {[
//                 ["Page publique en 1 clic","var(--pink)"],
//                 ["Carte intégrée","var(--yellow)"],
//                 ["Statistiques live","var(--green)"],
//                 ["Export PDF","var(--purple)"]
//               ].map(([t,c]) => (
//                 <span key={t} style={{
//                   background: c, color:"var(--ink)",
//                   padding:"8px 14px", borderRadius:999,
//                   fontFamily:"var(--font-body)", fontWeight:700,
//                   fontSize:11, letterSpacing:"0.06em", textTransform:"uppercase"
//                 }}>{t}</span>
//               ))}
//             </div>

//             <div className="row gap-3 wrap" style={{marginTop:8}}>
//               <a href="#/organization" className="btn btn-accent">
//                 Créer mon parcours →
//               </a>
//               <a href="#/organization" className="btn" style={{
//                 color:"var(--paper-warm)", border:"1.5px solid var(--paper-3)"
//               }}>
//                 Voir les tarifs
//               </a>
//             </div>

//             {/* Mini social proof */}
//             <div className="row gap-4" style={{marginTop:20, paddingTop:20, borderTop:"1px solid rgba(248,244,234,0.15)"}}>
//               <div className="row" style={{gap:0}}>
//                 {[1,2,3,4].map(i => (
//                   <div key={i} style={{
//                     width:36, height:36, borderRadius:"50%",
//                     overflow:"hidden", border:"2px solid var(--ink)",
//                     marginLeft: i>1 ? -10 : 0, background:"var(--paper-3)"
//                   }}>
//                     <img src={D.portrait("org-"+i, 80, 80)} alt=""
//                          style={{width:"100%", height:"100%", objectFit:"cover", filter:"grayscale(100%)"}}/>
//                   </div>
//                 ))}
//               </div>
//               <div className="stack gap-1" style={{lineHeight:1.2}}>
//                 <span style={{fontSize:14, fontWeight:600, color:"var(--paper-warm)"}}>32 organisations déjà actives</span>
//                 <span className="mono" style={{color:"var(--paper-3)"}}>Communes · ASBL · Collectifs · Centres culturels</span>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT — photo collage */}
//           <div style={{position:"relative", minHeight:540}}>
//             {/* Stat circle bottom-right */}
//             <div style={{
//               position:"absolute", top:0, right:0, zIndex:5,
//               width:130, height:130, borderRadius:"50%",
//               background:"var(--pink)", color:"var(--ink)",
//               border:"3px solid var(--ink)",
//               display:"flex", flexDirection:"column",
//               alignItems:"center", justifyContent:"center",
//               transform:"rotate(-6deg)",
//               boxShadow:"var(--shadow-l)"
//             }}>
//               <div className="display" style={{fontSize:38, lineHeight:1}}>49€</div>
//               <div className="mono" style={{fontSize:9, marginTop:2}}>/MOIS · TOUT INCLUS</div>
//             </div>

//             {/* Photo 1 — top, big */}
//             <div style={{
//               position:"absolute", top:40, left:40, width:"70%", height:280,
//               borderRadius:8, overflow:"hidden", border:"1.5px solid var(--ink)",
//               boxShadow:"var(--shadow-l)", zIndex:2, transform:"rotate(-2deg)"
//             }}>
//               <Tape color="yellow" style={{top:-12, left:50, width:110, height:22, transform:"rotate(-6deg)"}}/>
//               <img src={D.photo("org-photo-1", 800, 500)} alt=""
//                    style={{width:"100%", height:"100%", objectFit:"cover"}}/>
//             </div>

//             {/* Photo 2 — bottom-right, medium */}
//             <div style={{
//               position:"absolute", bottom:30, right:30, width:"58%", height:240,
//               borderRadius:8, overflow:"hidden", border:"1.5px solid var(--ink)",
//               boxShadow:"var(--shadow-l)", zIndex:3, transform:"rotate(3deg)"
//             }}>
//               <Tape color="pink" style={{top:-10, right:30, width:90, height:20, transform:"rotate(6deg)"}}/>
//               <img src={D.photo("org-photo-2", 700, 480)} alt=""
//                    style={{width:"100%", height:"100%", objectFit:"cover"}}/>
//             </div>

//             {/* Sticky note quote */}
//             <div style={{
//               position:"absolute", left:0, bottom:60, zIndex:4, maxWidth:260,
//               background:"var(--yellow)", color:"var(--ink)",
//               padding:"20px 22px", borderRadius:4,
//               transform:"rotate(-3deg)",
//               boxShadow:"var(--shadow-l)"
//             }}>
//               <div className="script" style={{fontSize:24, lineHeight:1.1}}>
//                 « Mis en ligne en une après-midi. »
//               </div>
//               <div className="mono" style={{marginTop:8, fontSize:10}}>
//                 — Office du Tourisme de Spa
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

window.LandingPage = LandingPage;
